import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, WrenchIcon, PhoneCallIcon } from 'lucide-react';
const steps = [{
  icon: SearchIcon,
  title: 'Diagnóstico Gratuito',
  description: 'Analizamos tu mercado local, tu competencia y las oportunidades que estás perdiendo. Sin costo, sin compromiso.'
}, {
  icon: WrenchIcon,
  title: 'Instalación del Sistema',
  description: 'Construimos tu landing page, configuramos tus campañas publicitarias y activamos el seguimiento automático en 7 días.'
}, {
  icon: PhoneCallIcon,
  title: 'Llamadas y Contratos',
  description: 'Tu teléfono empieza a sonar. Recibes leads exclusivos de personas que necesitan HVAC AHORA en tu zona.'
}];
export function ProcessSection() {
  return <section id="proceso" className="py-24 bg-[#000000] border-t border-white/5 relative overflow-hidden" data-id="element-246">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-247">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-248">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-249">
            ¿Cómo Funciona?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-[#C0C0C0]" data-id="element-250">
            Tu sistema de adquisición HVAC en{' '}
            <span className="text-[#FFD700] font-bold" data-id="element-251">3 pasos simples</span>
          </motion.p>
        </div>

        <div className="max-w-5xl mx-auto relative" data-id="element-252">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#50C878]/50 to-transparent -translate-y-1/2 z-0 shadow-[0_0_15px_rgba(80,200,120,0.3)]" data-id="element-253"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-254">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-255">
                <div className="w-20 h-20 bg-[#0A0A0A] border-2 border-[#50C878] rounded-full flex items-center justify-center mb-6 relative group-hover:scale-110 transition-transform duration-300 shadow-[0_0_20px_rgba(80,200,120,0.4)] group-hover:shadow-[0_0_30px_rgba(80,200,120,0.6)]" data-id="element-256">
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-[#FFD700] text-black font-black rounded-full flex items-center justify-center text-sm shadow-[0_0_10px_rgba(255,215,0,0.5)]" data-id="element-257">
                    {index + 1}
                  </div>
                  <step.icon className="w-8 h-8 text-[#50C878]" data-id="element-258" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4 group-hover:text-[#50C878] transition-colors" data-id="element-259">
                  {step.title}
                </h3>
                <p className="text-[#C0C0C0] leading-relaxed max-w-xs" data-id="element-260">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}